<template>
    <main id="js-page-content" class="citizens-v2" role="main">
        <portal to="ariane">
            <div class="tbv2-page-title">{{ $t('menu.companies.citizens') }}</div>
        </portal>

        <header class="citizens-hero">
            <h1 class="citizens-hero-title">{{ $t('company.citizens.title') }}</h1>
            <p class="citizens-hero-sub">{{ totalLabel }}</p>
        </header>

        <section class="citizens-card">
            <TabCitizens :loading="loading" @get-data="getData" />
        </section>
    </main>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import { mapActions, mapState } from 'vuex'
import TabCitizens from '@/components/Model/Company/TabCitizens'

export default {
    name: 'Citizens',
    components: {
        TabCitizens
    },
    data() {
        return {
            loading: false
        }
    },
    created() {
        this.getData()
    },
    computed: {
        ...mapState('company', {
            citizens: (state) => state.citizens
        }),
        totalLabel() {
            const n = Array.isArray(this.citizens)
                ? this.citizens.length
                : (this.citizens && this.citizens.total ? this.citizens.total : 0)
            const formatted = new Intl.NumberFormat(this.$i18n.locale).format(n)
            const key = n === 1 ? 'company.citizens.count_one' : 'company.citizens.count_other'
            return this.$t(key, { count: formatted })
        }
    },
    methods: {
        ...mapActions('company', ['getCitizens']),
        getData() {
            this.loading = true
            this.getCitizens()
                .catch((e) => {
                    this.$store.dispatch('dispatchError', e)
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>

<style scoped>
.citizens-v2 {
    width: 100%;
    padding: 24px 32px 48px;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.tbv2-page-title {
    font-size: 0.95rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    letter-spacing: -0.005em;
}

.citizens-hero {
    margin-bottom: var(--v2-space-5);
}

.citizens-hero-title {
    margin: 0 0 6px;
    font-size: 1.75rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    letter-spacing: -0.02em;
    line-height: 1.15;
}

.citizens-hero-sub {
    margin: 0;
    font-size: var(--v2-text-sm-size);
    color: var(--v2-text-3);
    line-height: 1.5;
}

.citizens-card {
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    overflow: hidden;
}

@media (max-width: 900px) {
    .citizens-v2 {
        padding: 16px 18px 32px;
    }

    .citizens-hero-title {
        font-size: 1.375rem;
    }
}
</style>
